module.exports = vendor_9bc47a73cdf0fba7b699;